import { render, staticRenderFns } from "./BulkDossierDownloadButton.vue?vue&type=template&id=420b269f&scoped=true"
import script from "./BulkDossierDownloadButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkDossierDownloadButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b269f",
  null
  
)

export default component.exports